document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {
        $(document).on('Searchanise.ResultsUpdated', function (event, container) {
            $('.snize-product', container).each(function () {
                if (!$('.snize-reviews span', this).length) {
                    $('.snize-reviews', this).append(`<span class='stars-container stars-0'>★★★★★</span>`);
                }
            });
        });
    })(window.Searchanise.$);
});